import Vue from 'vue'

const API_AUTH_REFRESH = '/api/wechat/auth/token/refresh'

export default () => {
  return Vue.http.post(API_AUTH_REFRESH)
}



// WEBPACK FOOTER //
// ./src/api/auth/refresh.js